
import {Component, Vue, Prop, Inject} from 'vue-property-decorator'
    import { GeneralInsurance } from '@/app/general-insurance/entities/general-insurance.entity'
    import SimpleTable from '@/app/common/components/simple-table.vue'
    import { GeneralInsurancePolicyDownloadDocumentCommand } from "@/app/general-insurance/commands/general-insurance-policy-download-document.command";

    @Component({
        computed: {
            GeneralInsurance() {
                return GeneralInsurance
            }
        },
        components: { SimpleTable }
    })
    export default class GeneralInsuranceOverview extends Vue {
        @Prop({ type: GeneralInsurance, required: true }) generalInsurance!: GeneralInsurance

        @Inject() generalInsurancePolicyDownloadDocumentCommand!: GeneralInsurancePolicyDownloadDocumentCommand

        async downloadDocument(apiId: string) {
            await this.generalInsurancePolicyDownloadDocumentCommand.run(this.generalInsurance.apiId)
        }
    }
